import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReferralHash from "../../../../common/referral-hash";

import {
  getSettingsAction,
  getUserDataAction,
  getReasonsAction,
  setDetailsAction,
  setAboutAction,
  getInterestsAction,
  getAgeAction,
  getDiversityAction,
  chooseMembershipAction,
  getCreditCardAction,
  setCreditCardAction,
  deleteCreditCardAction,
  setBillingAddressAction,
  getTermsAndConditionsAction,
  acceptTermsAndConditionsAction,
  resendVerificationMessageAction,
} from "features/application/form/redux/actions";

import {
  setValidFieldAction,
  removeValidFieldAction,
  setInvalidFieldAction,
  removeInvalidFieldAction,
  removeFieldsCorrectnessAction,
} from "features/application/field/redux/actions";

import { sendEvent } from "screens/application/requests/send-event";
import FormView from "features/application/form/component/view";

const mapStateToProps = (state) => ({
  settings: state.formReducer.settings,
  reasons: state.formReducer.reasons,
  interests: state.formReducer.interests,
  age: state.formReducer.age,
  diversity: state.formReducer.diversity,
  creditCard: state.formReducer.creditCard,
  billingAddress: state.formReducer.billingAddress,
  termsAndConditions: state.formReducer.termsAndConditions,
  validFields: state.fieldReducer.validFields,
  invalidFields: state.fieldReducer.invalidFields,
});

const mapDispatchToProps = (dispatch) => ({
  getSettings: () => dispatch(getSettingsAction()),
  getUserData: () => dispatch(getUserDataAction()),
  getReasons: () => dispatch(getReasonsAction()),
  setDetails: (details) => dispatch(setDetailsAction(details)),
  setAbout: (about) => dispatch(setAboutAction(about)),
  getInterests: () => dispatch(getInterestsAction()),
  getAge: () => dispatch(getAgeAction()),
  getDiversity: () => dispatch(getDiversityAction()),
  chooseMembership: (id, isPayable, membership) =>
    dispatch(chooseMembershipAction(id, isPayable, membership)),
  getCreditCard: () => dispatch(getCreditCardAction()),
  setCreditCard: (creditCard) => dispatch(setCreditCardAction(creditCard)),
  deleteCreditCard: (id) => dispatch(deleteCreditCardAction(id)),
  setBillingAddress: (id, billingAddress) =>
    dispatch(setBillingAddressAction(id, billingAddress)),
  getTermsAndConditions: () => dispatch(getTermsAndConditionsAction()),
  acceptTermsAndConditions: () => dispatch(acceptTermsAndConditionsAction()),
  resendVerificationMessage: (email) =>
    dispatch(resendVerificationMessageAction(email)),
  setValidField: (name) => dispatch(setValidFieldAction(name)),
  removeValidField: (name) => dispatch(removeValidFieldAction(name)),
  setInvalidField: (name) => dispatch(setInvalidFieldAction(name)),
  removeInvalidField: (name) => dispatch(removeInvalidFieldAction(name)),
  removeFieldsCorrectness: () => dispatch(removeFieldsCorrectnessAction()),
});

class Form extends Component {
  constructor(props) {
    super(props);

    this.formReference = React.createRef();

    this.backToPreviousStep = this.backToPreviousStep.bind(this);
    this.sendApiRequest = this.sendApiRequest.bind(this);
  }

  componentDidMount() {
    const { currentStep } = this.props;

    this.getAppropriateData(currentStep);

    window.addEventListener("storage", this.reloadTabs);
  }

  reloadTabs(event) {
    if (event.key === "emailConfirmed" && JSON.parse(event.newValue)) {
      window.location.reload();

      localStorage.removeItem("emailConfirmed");
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      responseCodes,
      errorFields,
      currentStep,
      removeFieldsCorrectness,
      getCreditCard,
    } = this.props;

    if (nextProps.currentStep && nextProps.currentStep !== currentStep) {
      this.getAppropriateData(nextProps.currentStep);

      removeFieldsCorrectness();

      setTimeout(() => window.scrollTo(0, 0));
    }

    nextProps.responseCodes &&
      JSON.stringify(nextProps.responseCodes) !==
        JSON.stringify(responseCodes) &&
      nextProps.responseCodes.deletion &&
      getCreditCard();

    if (nextProps.errorFields && nextProps.errorFields !== errorFields) {
      for (let field in nextProps.errorFields) {
        this.setError(field);
      }
    }
  }

  setError(name) {
    const { removeValidField, setInvalidField } = this.props;

    removeValidField(name);
    setInvalidField(name);
  }

  removeError(name) {
    const { setValidField, removeInvalidField } = this.props;

    setValidField(name);
    removeInvalidField(name);
  }

  getAppropriateData(currentStep) {
    const {
      getUserData,
      getSettings,
      getReasons,
      getInterests,
      getAge,
      getDiversity,
      getCreditCard,
      getTermsAndConditions,
    } = this.props;

    getUserData();

    switch (currentStep) {
      case "reasons-to-join":
        getReasons();
        break;
      case "interests":
        getInterests();
        getAge();
        getDiversity();
        break;
      case "memberships":
        getSettings();
        break;
      case "payment":
        getCreditCard();
        break;
      case "email-confirmation":
        getTermsAndConditions();
        break;
    }
  }

  sendAboutData(fields, image) {
    const { setAbout } = this.props;

    let about = {
      avatar_file: image,
      education:
        fields.education && fields.education.value
          ? fields.education.value
          : null,
      company:
        fields.company && fields.company.value ? fields.company.value : null,
      position:
        fields.position && fields.position.value ? fields.position.value : null,
      instagram_link:
        fields.instagram_link && fields.instagram_link.value
          ? fields.instagram_link.value.toLowerCase().trim()
          : null,
      linkedin_link:
        fields.linkedin_link && fields.linkedin_link.value
          ? fields.linkedin_link.value.toLowerCase().trim()
          : null,
      bio: fields.bio && fields.bio.value ? fields.bio.value : null,
    };

    setAbout(about);
  }

  backToPreviousStep() {
    const { currentStep, history, userData, memberships } = this.props;

    switch (currentStep) {
      case "details":
        history.replace(
          "/application/reasons-to-join" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
        break;
      case "interests":
        history.replace(
          "/application/details" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
        break;
      case "about":
        history.replace(
          "/application/interests" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
        break;
      case "memberships":
        history.replace(
          "/application/about" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
        break;
      case "payment":
        userData.use_payment
          ? history.replace(
              "/application/memberships" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            )
          : history.replace(
              "/application/about" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
        break;
      case "email-confirmation":
        if (
          !userData.is_referred &&
          userData.use_payment &&
          memberships.find(
            (membership) => membership.id === userData.plan_id
          ) &&
          !memberships.find((membership) => membership.id === userData.plan_id)
            .is_free
        ) {
          history.replace(
            "/application/payment" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        } else if (
          userData.is_referred ||
          !userData.use_payment ||
          (memberships.find(
            (membership) => membership.id === userData.plan_id
          ) &&
            memberships.find((membership) => membership.id === userData.plan_id)
              .is_free)
        ) {
          if (userData.use_payment) {
            if (userData.is_referred) {
              history.replace(
                "/application/about" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else {
              history.replace(
                "/application/memberships" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            }
          } else {
            history.replace(
              "/application/about" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        }
        break;
    }
  }

  sendApiRequest(event, image = null) {
    event.preventDefault();

    const {
      currentStep,
      settings,
      userData,
      setDetails,
      //creditCard,
      setCreditCard,
      chooseMembership,
      //setBillingAddress,
      resendVerificationMessage,
      acceptTermsAndConditions,
      validFields,
      invalidFields,
      memberships,
    } = this.props;

    let fields = event.target.elements;
    let clickEvent = new Event("click", { bubbles: true, cancelable: true });
    let changeEvent = new Event("change", { bubbles: true, cancelable: true });
    let focusEvent = new Event("focus", { bubbles: true, cancelable: true });
    let blurEvent = new Event("blur", { bubbles: true, cancelable: true });

    if (fields) {
      for (let i = 0; i < fields.length; i++) {
        switch (fields[i].type) {
          case "file":
            fields[i].onclick = (event) => event.preventDefault();
            fields[i].dispatchEvent(clickEvent);
            fields[i].onclick = () => true;
            fields[i].dispatchEvent(changeEvent);
            break;
          case "checkbox":
            fields[i].dispatchEvent(clickEvent);
            break;
          default:
            fields[i].dispatchEvent(focusEvent);
            fields[i].dispatchEvent(blurEvent);
            break;
        }
      }
    }

    let path;

    switch (currentStep) {
      case "details":
        if (
          validFields.includes("first_name") &&
          validFields.includes("last_name") &&
          validFields.includes("gender") &&
          validFields.includes("day") &&
          validFields.includes("month") &&
          validFields.includes("year") &&
          validFields.includes("home_address_zip") &&
          validFields.includes("work_address_zip") &&
          !invalidFields.includes("day") &&
          !invalidFields.includes("month") &&
          !invalidFields.includes("year")
        ) {
          setDetails({
            first_name: fields.first_name.value,
            last_name: fields.last_name.value,
            gender: fields.gender.value,
            birthday: `${fields.year.value}-${
              fields.month.value.length === 1 ? "0" : ""
            }${fields.month.value}-${fields.day.value.length === 1 ? "0" : ""}${
              fields.day.value
            }`,
            home_address_zip: fields.home_address_zip.value,
            work_address_zip: fields.work_address_zip.value,
          });

          path = window.location.pathname;

          setTimeout(() => {
            if (path === window.location.pathname) {
              sendEvent(currentStep);
            }
          }, 4000);

          window.dataLayer.push({ event: "detailsNextClicked" });
        }
        break;
      case "about":
        if (
          (userData.is_referred &&
            image.includes("base64") &&
            validFields.includes("company") &&
            validFields.includes("position") &&
            validFields.includes("instagram_link") &&
            validFields.includes("linkedin_link")) ||
          (!userData.is_referred &&
            image.includes("base64") &&
            validFields.includes("education") &&
            validFields.includes("company") &&
            validFields.includes("position") &&
            validFields.includes("instagram_link") &&
            validFields.includes("linkedin_link") &&
            validFields.includes("bio"))
        ) {
          this.sendAboutData(fields, image);

          path = window.location.pathname;

          setTimeout(() => {
            if (path === window.location.pathname) {
              sendEvent(currentStep);
            }
          }, 4000);

          window.dataLayer.push({ event: "aboutNextClicked" });
        }
        break;
      case "memberships":
        chooseMembership(
          parseInt(event.target.dataset.membership),
          settings.enable_payment_in_application,
          memberships.find(
            (membership) =>
              membership.id === parseInt(event.target.dataset.membership)
          )
        );

        path = window.location.pathname;

        setTimeout(() => {
          if (path === window.location.pathname) {
            sendEvent(currentStep);
          }
        }, 4000);

        window.dataLayer.push({
          event: JSON.parse(event.target.dataset.isfree)
            ? "standardMembershipChose"
            : "premiumMembershipChose",
        });
        break;
      case "payment":
        if (
          validFields.includes("number") &&
          validFields.includes("validity") &&
          validFields.includes("cvc") &&
          validFields.includes("name") &&
          validFields.includes("address_line1") &&
          validFields.includes("address_city") &&
          validFields.includes("address_state") &&
          validFields.includes("address_zip")
        ) {
          setCreditCard({
            number: fields.number.value,
            exp_month: fields.validity.value.split("/")[0],
            exp_year: fields.validity.value.split("/")[1],
            cvc: fields.cvc.value,
            name: fields.name.value,
            address_line1: fields.address_line1.value,
            address_line2: null,
            address_city: fields.address_city.value,
            address_state: fields.address_state.value,
            address_zip: fields.address_zip.value,
          });

          path = window.location.pathname;

          setTimeout(() => {
            if (path === window.location.pathname) {
              sendEvent(currentStep);
            }
          }, 4000);

          window.dataLayer.push({ event: "paymentNextClicked" });
        } else if (
          !invalidFields.includes("number") &&
          !invalidFields.includes("validity") &&
          !invalidFields.includes("cvc") &&
          validFields.includes("name") &&
          validFields.includes("address_line1") &&
          validFields.includes("address_city") &&
          validFields.includes("address_state") &&
          validFields.includes("address_zip")
        ) {
          /*setBillingAddress(
                      creditCard[0].id,
                      {
                        name: fields.name.value,
                        address_line1: fields.address_line1.value,
                        address_line2: null,
                        address_city: fields.address_city.value,
                        address_state: fields.address_state.value,
                        address_zip: fields.address_zip.value,
                      },
                      memberships.find((membership) => membership.id === userData.plan_id)
                    );*/

          path = window.location.pathname;

          setTimeout(() => {
            if (path === window.location.pathname) {
              sendEvent(currentStep);
            }
          }, 4000);

          window.dataLayer.push({ event: "paymentNextClicked" });
        }
        break;
      case "email-confirmation":
        if (validFields.includes("email")) {
          resendVerificationMessage(fields.email.value);
        } else if (validFields.includes("termsAndConditions")) {
          acceptTermsAndConditions();

          window.dataLayer.push({ event: "termsAndConditionsSubmitClicked" });
        }
        break;
    }
  }

  render() {
    const {
      responseCodes,
      errorCodes,
      currentStep,
      userData,
      reasons,
      interests,
      age,
      diversity,
      memberships,
      billingAddress,
      deleteCreditCard,
      termsAndConditions,
      resendVerificationMessage,
      validFields,
      invalidFields,
      removeValidField,
      setInvalidField,
    } = this.props;

    return (
      <FormView
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        currentStep={currentStep}
        userData={userData}
        reasons={reasons}
        interests={interests}
        age={age}
        diversity={diversity}
        memberships={memberships}
        billingAddress={billingAddress}
        deleteCreditCard={deleteCreditCard}
        termsAndConditions={termsAndConditions}
        resendVerificationMessage={resendVerificationMessage}
        validFields={validFields}
        invalidFields={invalidFields}
        removeValidField={removeValidField}
        setInvalidField={setInvalidField}
        backToPreviousStep={this.backToPreviousStep}
        sendApiRequest={this.sendApiRequest}
      />
    );
  }
}

Form.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  errorFields: PropTypes.object,
  currentStep: PropTypes.string,
  userData: PropTypes.object,
  memberships: PropTypes.array,
  removeFieldsCorrectness: PropTypes.func,
  getCreditCard: PropTypes.func,
  removeValidField: PropTypes.func,
  setInvalidField: PropTypes.func,
  setValidField: PropTypes.func,
  removeInvalidField: PropTypes.func,
  getUserData: PropTypes.func,
  getSettings: PropTypes.func,
  getReasons: PropTypes.func,
  getInterests: PropTypes.func,
  getAge: PropTypes.func,
  getDiversity: PropTypes.func,
  getTermsAndConditions: PropTypes.func,
  setAbout: PropTypes.func,
  history: PropTypes.object,
  settings: PropTypes.object,
  setDetails: PropTypes.func,
  creditCard: PropTypes.array,
  setCreditCard: PropTypes.func,
  chooseMembership: PropTypes.func,
  setBillingAddress: PropTypes.func,
  resendVerificationMessage: PropTypes.func,
  acceptTermsAndConditions: PropTypes.func,
  validFields: PropTypes.array,
  invalidFields: PropTypes.array,
  reasons: PropTypes.array,
  interests: PropTypes.array,
  age: PropTypes.array,
  diversity: PropTypes.array,
  billingAddress: PropTypes.object,
  deleteCreditCard: PropTypes.func,
  termsAndConditions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form));
